import {Observable}                  from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';
import Playback               from '../Playback';

const createTimelineTapStream = (
    uiEvents$: Observable<IUiEventsStreamPayload>,
    playbackStoreUpdate$: Observable<Playback>
): Observable<number> =>
    uiEvents$
        .pipe(
            filter(({type}) => type === UiEventType.TIMELINE_TAP),
            withLatestFrom(playbackStoreUpdate$),
            map(([{eventData}, {minTime, duration}]) => minTime + (eventData.multiplier * duration))
        );

export default createTimelineTapStream;